import styled, { css } from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

const TERM_LIST = [
  '포인트 사용은 닥터나우 앱 결제 시에만 적용돼요.',
  '비급여 진료 시에 최대 49% 사용이 가능하며,\n100P 이상부터 사용할 수 있습니다.',
];

const PointTermInfo = () => {
  return (
    <Wrapper>
      <Title>
        <MaterialIcon name='info' size={20} color={theme.color.blue500} />
        결제 안내
      </Title>
      <DescriptionWrapper>
        {TERM_LIST.map((term) => (
          <Description key={term}>
            <TermListDecoration>•</TermListDecoration>
            <Term>{term}</Term>
          </Description>
        ))}
      </DescriptionWrapper>
    </Wrapper>
  );
};

export default PointTermInfo;

const Description = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: baseline;
`;

const TermListDecoration = styled.div`
  color: ${theme.color.gray200};
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: ${({ theme }) => theme.color.gray20};
  border-radius: 8px;
  margin: 0 24px;
  padding: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.color.blue500};
  ${({ theme }) => theme.typography.UI15M};
  display: flex;
  gap: 4px;
`;

const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Term = styled.span`
  position: relative;
  justify-content: flex-start;
  white-space: break-spaces;

  ${({ theme }) => css`
    ${theme.typography.UI13M}
    color: ${theme.color.gray400};
  `}
`;
